import { AddressType } from './AddressType';

/**
 * @deprecated This constant is deprecated and should not be used in new code.
 * Use EMPTY_ADDRESS from application-types instead.
 */
export const EMPTY_ADDRESS: AddressType = {
  _id: '',
  name: '',
  street1: '',
  street2: '',
  street3: '',
  city: '',
  country: '',
  code: '',
  state: '',
  geo: [0, 0],
};
